// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"14fb9be9","142":"f529f6ef","358":"d9a71a76","438":"51544662","648":"56a78173","829":"341c1a20","858":"428a88bf"}[chunkId] + ".chunk.js";
};